import MyClaimClaimGroupsNavigationDefault from "@rd-web-markets/shared/dist/my/MyClaimClaimGroupsNavigationDefault";
export default MyClaimClaimGroupsNavigationDefault;